import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
	AddLink,
	FormatBold,
	FormatItalic,
	FormatListBulleted,
	FormatListNumbered,
	FormatStrikethrough,
	FormatUnderlined,
	LinkOff,
} from '@mui/icons-material';
import { Box, IconButton, Stack, styled } from '@mui/material';
import { FC } from 'react';
import { FORMAT_TEXT_COMMAND } from 'lexical';
import { INSERT_ORDERED_LIST_COMMAND, INSERT_UNORDERED_LIST_COMMAND } from '@lexical/list';
import { TOGGLE_LINK_COMMAND } from '@lexical/link';
import { sanitizeUrl } from './utils/url';
import { getNightOrDayPalette } from '../../utils/getNightOrDayPalette';
import { ThemeMode } from '../../types/config';

const Divider = styled(Box)(({ theme }) => ({
	width: '1px',
	background: theme.palette[getNightOrDayPalette(theme)][400],
}));

export const Toolbar: FC = () => {
	const [editor] = useLexicalComposerContext();

	return (
		<Stack
			flexDirection={'row'}
			px={2}
			py={1}
			gap={1}
			alignItems={'stretch'}
			sx={{
				overflowX: 'auto',
			}}
			borderBottom={(theme) => `1px solid ${theme.palette.mode === ThemeMode.DARK ? theme.palette.night[500] : theme.palette.day[300]}`}
		>
			<IconButton onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'bold')}>
				<FormatBold />
			</IconButton>
			<IconButton onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'italic')}>
				<FormatItalic />
			</IconButton>
			<IconButton onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'underline')}>
				<FormatUnderlined />
			</IconButton>
			<IconButton onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'strikethrough')}>
				<FormatStrikethrough />
			</IconButton>
			<Divider />
			<IconButton onClick={() => editor.dispatchCommand(TOGGLE_LINK_COMMAND, sanitizeUrl('https://'))}>
				<AddLink />
			</IconButton>
			<IconButton onClick={() => editor.dispatchCommand(TOGGLE_LINK_COMMAND, null)}>
				<LinkOff />
			</IconButton>
			<Divider />
			<IconButton onClick={() => editor.dispatchCommand(INSERT_UNORDERED_LIST_COMMAND, undefined)}>
				<FormatListBulleted />
			</IconButton>
			<IconButton onClick={() => editor.dispatchCommand(INSERT_ORDERED_LIST_COMMAND, undefined)}>
				<FormatListNumbered />
			</IconButton>
		</Stack>
	);
};
